import React from 'react';
import {Divider, Grid, Typography} from "@mui/material";
import styles from "../../container/AirQualityContainer/styles.module.css";
import Box from "@mui/material/Box";


const WidgetFooter = () => {

    const boxLocation = process.env.REACT_APP_TOWN_LABEL;
    let minimalWidgetFooter;


    if (process.env.REACT_APP_FOOTER_LOGO === 'HEILBAEDER') {
        minimalWidgetFooter = <Box sx={{flexGrow: 1}}>
            <Grid container spacing={3}>
                <Grid item xs={1}/>

                <Grid item xs={10} className={styles.textMargin}>
                    <Typography variant="body1">Ihre Gesundheit liegt uns am Herzen.</Typography>
                    <Typography variant="body1">Die Messstation liegt direkt im heilklimatischen Kurort {boxLocation}.</Typography>

                    <Typography variant="body1">Weitere Infos zum Projekt, <a
                        href={'https://www.heilbaeder-bw.de/luftqualitaet'}
                        rel={'noreferrer'}
                        target={'_blank'}>hier</a> klicken.</Typography>


                </Grid>
                <Grid item xs={1}/>

                <Grid item xs={6} className={styles.textAlignRight}>
                    <img height={50}
                         src="https://upload.wikimedia.org/wikipedia/de/3/31/Bosch-logotype.svg?auto=compress&cs=tinysrgb"
                         alt="new"/>
                </Grid>
                <Grid item xs={6} className={styles.textAlignLeft}>
                    <img height={30} className={styles.topMargin}
                         src="https://www.heilbaeder-bw.de/_Resources/Static/Packages/Newland.HbvTheme/images/footer-logo.png"
                         alt="new"/>
                    <br/><br/>
                </Grid>

                <Grid item xs={12}>
                    <Divider/>
                    <br/><br/>
                    <div className={styles.poweredBySection}>powered by</div>
                    <img height={45} className={styles.topMargin}
                         src="https://mein.toubiz.de/dist/f89f4969be28761c9a0120cfa90c8023.svg"
                         alt="logo_mein_toubiz"/>
                </Grid>

            </Grid>
        </Box>
    } else if (process.env.REACT_APP_FOOTER_LOGO === 'BOSCH') {
        minimalWidgetFooter = <Box sx={{flexGrow: 1}}>
            <Grid container spacing={3}>;
                <Grid item xs={12}>
                    <div className={styles.poweredBySection}>powered by</div>
                </Grid>
                <Grid item xs={12}>
                    <img height={40}
                         src="https://upload.wikimedia.org/wikipedia/de/3/31/Bosch-logotype.svg?auto=compress&cs=tinysrgb"
                         alt="logo_bosch"/>
                </Grid>
            </Grid>
        </Box>;
    }


    return (
        <React.Fragment>
            {minimalWidgetFooter}
        </React.Fragment>
    );
}

export default WidgetFooter;